import Icon from '@components/icon/Icon';

interface LogoDeleteIconProps {
  onDelete: () => void;
}

const LogoDeleteIcon = ({ onDelete }: LogoDeleteIconProps) => (
  <div className="absolute left-0 top-0 hidden size-full items-center justify-center rounded-xl bg-black/10 group-hover:flex">
    <div
      className="blur-box flex size-10 cursor-pointer items-center justify-center rounded-full bg-cofeeNeutral1 p-2"
      onClick={onDelete}
      role="button"
      tabIndex={0}
      aria-label="Delete logo"
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onDelete();
        }
      }}
    >
      <Icon name="trash" className="text-cofeeNeutral1" aria-hidden="true" />
    </div>
  </div>
);

export default LogoDeleteIcon;
